import React from 'react';
import { Box, Typography } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { buildCommercialDetailView } from '../commercialSummary';

/**
 * Línea arriba del listado de UF del Dock (`commercial_rollup`, lote + UF):
 * solo el detalle ("1 cerrado · 5 sin interés · 1 lead · 1 consulta ·
 * Última actividad: hoy", mismo desglose que las cards) y la nota de mismatch, secundaria. Sin título ni
 * estado: la etapa ya se ve en cada UF. Nada que mostrar → null.
 * @see docs/frontend/commercial-summary.md
 */
export default function CommercialRollupDetails({ rollup, lotSummary = null, sx }) {
  const view = buildCommercialDetailView(rollup, { kind: 'rollup', lotSummary });
  if (!view || (view.details.length === 0 && !view.mismatch)) return null;
  return (
    <Box data-testid="commercial-rollup-details" sx={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0, ...sx }}>
      {view.details.length > 0 ? (
        <Typography data-testid="commercial-rollup-line" sx={{ fontSize: '12px', lineHeight: '16px', color: '#D4D4D4' }}>
          {view.details.join(' · ')}
        </Typography>
      ) : null}
      {view.mismatch ? (
        <Box data-testid="commercial-rollup-mismatch" sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
          {view.mismatchMark ? <ReportProblemOutlinedIcon sx={{ fontSize: 12, color: '#ABABAB', mt: '2px' }} /> : null}
          <Typography sx={{ fontSize: '11px', color: '#ABABAB' }}>{view.mismatch}</Typography>
        </Box>
      ) : null}
    </Box>
  );
}
